<template>
  <div id="paginaTracciatiBiglietteria">
    <!-- Elementi Pagina----------------------------------------------------------------------------------- -->
    <b-row class="match-height">

      <!-- Card Elenco DropdownList: -->
      <b-col xl="12" md="12">
        <b-card tag="article" class="mb-2">
          <b-card-header class="align-items-baseline">
            <div>
              <b-card-title>Tracciati Biglietteria</b-card-title>
              <b-card-text class="mb-0">
                Teatro Coccia
              </b-card-text>
            </div>
            <!-- dropdown menù laterale dx -->
            <b-dropdown variant="link" no-caret right class="chart-dropdown" toggle-class="p-0">
              <template #button-content>
                <feather-icon icon="MoreVerticalIcon" size="18" class="text-body cursor-pointer" />
              </template>
              <b-dropdown-item href="#">
                ...
              </b-dropdown-item>
            </b-dropdown>
          </b-card-header>
          <b-card-body class="mb-0">
            <!-- card body -->
            <b-row>
              <!-- Input di tipo dropdown collegato: anno  -->
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id='dropAnni' ref='dropAnni' :query='queryAnni' :dataSource='anniData'
                  :index='anniIndex' :fields='anniFields' v-model="annoCorrente" :change='onAnnoChange'
                  placeholder='Seleziona un Anno'></ejs-dropdownlist>
              </b-col>
              <!-- Input di tipo dropdown collegato: mese  -->
              <b-col xl="12" md="12" class="pt-1">
                <ejs-dropdownlist id='dropMesi' ref='dropMesi' :query='queryMesi' :dataSource='mesiData'
                  :index='mesiIndex' :fields='mesiFields' :enabled='dropMesiEnabled' v-model="meseCorrente"
                  :change='onMeseChange' placeholder='Seleziona un Mese'></ejs-dropdownlist>
              </b-col>
              <!-- Riga vuota per spaziatura -->
              <b-col xl="12" md="12" class="pt-1"></b-col>
              <!-- Input di tipo alert per messaggi gridA  -->
              <b-col xl="12" md="12" class="pt-1">
                <b-alert :show="alertADismissCountDown" dismissible variant="warning"
                  @dismissed="alertADismissCountDown = 0" @dismiss-count-down="alertACountDownChanged">
                  <p>Occorre selezionare una riga della tabella</p>
                  <b-progress variant="warning" :max="alertADismissSecs" :value="alertADismissCountDown" height="4px" />
                </b-alert>
              </b-col>
              <b-col xl="12" md="12" class="pt-1">
                <!-- Input di tipo grid: tracciatiBiglFullData  -->
                <div id="GridParent">
                  <ejs-grid id="gridA" ref="gridA" :dataSource="tracciatiBiglFullData" :allowSorting="true"
                    :toolbarClick="gridAClickHandler" :toolbar="gridA.toolbarOptions" :height="gridA.height"
                    :allowFiltering="true" :filterSettings="gridA.filterOptions" :editSettings="gridA.editOptions"
                    :actionBegin="gridAactionBegin" :actionComplete="gridAactionComplete">
                    <e-columns>
                      <e-column field="id" headerText="ID" :isPrimaryKey="true" width="60"></e-column>
                      <e-column field="data" headerText="Data" :format="settings.formatoData" type='date' width="100"></e-column>
                      <e-column field="nome" headerText="Nome" width="100"></e-column>
                      <e-column field="annotazione" headerText="Annotazione" width="200"></e-column>
                    </e-columns>
                  </ejs-grid>
                </div>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-col>

    </b-row>



  </div>
</template>

<script>
import Vue from 'vue'
import useJwt from '@/auth/jwt/useJwt'
// import bootstrap-Vue
import {
  LayoutPlugin, CardPlugin, DropdownPlugin, AlertPlugin
} from 'bootstrap-vue'
// import Syncfusion
import { enableRipple } from '@syncfusion/ej2-base'
import { Query } from '@syncfusion/ej2-data'
import { ButtonPlugin } from '@syncfusion/ej2-vue-buttons'
import {
  TextBoxPlugin, UploaderPlugin,
} from '@syncfusion/ej2-vue-inputs'
import {
  DropDownListPlugin, ListBoxPlugin, CheckBoxSelection,
} from '@syncfusion/ej2-vue-dropdowns'
import {
  GridPlugin, Edit as GridEdit, Toolbar as GridToolbar, Sort as GridSort, Filter as GridFilter,
} from '@syncfusion/ej2-vue-grids'

// use bootstrap-vue
Vue.use(CardPlugin)
Vue.use(LayoutPlugin)
Vue.use(DropdownPlugin)
Vue.use(AlertPlugin)
// use Syncfusion
Vue.use(TextBoxPlugin)
Vue.use(UploaderPlugin)
Vue.use(DropDownListPlugin)
Vue.use(ButtonPlugin)
Vue.use(ListBoxPlugin)
Vue.use(GridPlugin)
enableRipple(true)
// api
const apiTracciatiRicercaUrl = '/demo/api/tracciati/ricerca'
const apiTracciatiDownloadUrl = '/demo/api/tracciati/download'

export default Vue.extend({
  components: {
  },
  data() {
    return {
      // per dropdownlist combinate
      // mese, anno selezionati
      annoCorrente: null,
      meseCorrente: null,
      anniData: [
        { label: '2021', id: '2021' },  
        { label: '2022', id: '2022' },
        { label: '2023', id: '2023' },
        { label: '2024', id: '2024' },
        { label: '2025', id: '2025' },
        { label: '2026', id: '2026' },
      ],
      mesiData: [
        { label: 'Gennaio', id: '01' },
        { label: 'Febbraio', id: '02' },
        { label: 'Marzo', id: '03' },
        { label: 'Aprile', id: '04' },
        { label: 'Maggio', id: '05' },
        { label: 'Giugno', id: '06' },
        { label: 'Luglio', id: '07' },
        { label: 'Agosto', id: '08' },
        { label: 'Settembre', id: '09' },
        { label: 'Ottobre', id: '10' },
        { label: 'Novembre', id: '11' },
        { label: 'Dicembre', id: '12' },
      ],
      anniFields: { value: 'id', text: 'label' },
      mesiFields: { value: 'id', text: 'label' },
      anniIndex: -1,
      mesiIndex: -1,
      dropMesiEnabled: false,
      queryAnni: null,
      queryMesi: null,
      // generali
      settings: {
        formatoData: 'dd-MM-yyyy',
        formatoOra: 'HH:mm',
        intervalloOra: 15,
        listboxSelectionSettings: { showCheckbox: true },
      },
      // tracciatiBigl
      tracciatiBiglFullData: [], // elenco completo dati tracciatiBigl
      tracciatiBiglActiveId: 0, // Id scrittura artistica attivo (0 se nuovo)
      tracciatiBiglActiveData: {}, // dati completi dell scrittura artistica attivo
      tracciatiBiglSavedData: {}, // dati completi dell scrittura artistica attivo
      tracciatiBiglDefaultData: {}, // dati completi di default per nuovi tracciatiBigl

      // per alertA
      alertADismissSecs: 3,
      alertADismissCountDown: 0,

      // per dialogA1
      dialogA1: {
        header: '',
        visible: false,
        showCloseIcon: true,
        buttons: [{ click: this.dialogA1Ok, buttonModel: { content: 'OK', isPrimary: true } },
        { click: this.dialogA1Cancel, buttonModel: { content: 'Cancel' } }],
        animationSettings: { effect: 'FadeZoom', duration: 400, delay: 0 }, // { effect: 'None' }, // selezionata per primo livello
        zIndex: 1050,
        tabAdialogA1Index: 0,
      },
      // per gridA
      gridAFlag: false,
      gridA: {
        height: 300,
        editOptions: {
          allowEditing: false,
          allowDeleting: false,
        },
        filterOptions: { type: 'Excel' },
        toolbarOptions: [
          {
            text: 'Scarica tracciato', tooltipText: 'Scarica contratto', prefixIcon: 'e-save', id: 'download',
          },
          'Search',
        ],
      }, //



    }
  },
  created() {
    // log
    console.log('Pagina Visualizza Tracciati Biglietteria Creata')
    // inizializzazione elenchi dal backend
    // chiamate API
    console.log('Recupero elenchi dal backend')

    this.tracciatiBiglDefaultData = {}
  },
  mounted() {
    // disabilito gridA
    this.$refs.gridA.$el.classList.add('disablegrid')
    document.getElementById("GridParent").classList.add('wrapper')
    // focus su dropAnni
    this.$refs.dropAnni.ej2Instances.focusIn()
  },

  provide: {
    // per grid
    grid: [GridToolbar, GridSort, GridFilter, GridEdit],
    // per listBox
    listbox: [CheckBoxSelection],
  },
  methods: {
    // per dropdownlist combinate
    onAnnoChange: function (e) {
      this.dropMesiEnabled = true;
    },
    onMeseChange: function (e) {
      console.log(this.annoCorrente)
      console.log(this.meseCorrente)
      const datiDaInviare = {
        anno: this.annoCorrente,
        mese: this.meseCorrente,
      }
      if (localStorage.getItem('userData') !== null) {
        useJwt.post(apiTracciatiRicercaUrl, datiDaInviare).then(d => {
          // gestione risposta
          this.tracciatiBiglFullData = d.data
          this.tracciatiBiglFullData = [...this.tracciatiBiglFullData]
        })
        // abilito gridA
        this.$refs.gridA.$el.classList.remove('disablegrid');
        document.getElementById("GridParent").classList.remove('wrapper');
      } else {
        console.log('Non trovo UserData, prova ancora')
      }
    },
    // per gridA
    gridAClickHandler(args) {
      if (args.item.id === 'download') {
        let found = false
        console.log('download tracciato')
        try {
          const selectedRow = this.$refs.gridA.getSelectedRecords()
          const idRiga = selectedRow[0].id
          console.log(selectedRow[0].id)
          console.log(selectedRow[0].data)
          const nomeFile = 'tracciato_' + selectedRow[0].data + '.txt'
          const datiDaInviare = { id: idRiga }

          useJwt.post(apiTracciatiDownloadUrl, datiDaInviare, { responseType: 'blob' }).then(response => {
            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url
            link.setAttribute('download', nomeFile)
            document.body.appendChild(link)
            link.click()
          })
        } catch (err) {
          console.log('Occorre selezionare una riga della tabella')
          this.alertAShow()
        }
      }
    },
    gridAactionBegin(e) {
      if (!this.gridAFlag) {
        // Add and edit operations
      }
    },
    // Grid’s actionComplete event handler
    // Triggers after an action is completed
    gridAactionComplete(e) {
    },

    // per alert
    alertACountDownChanged(alertADismissCountDown) {
      this.alertADismissCountDown = alertADismissCountDown
    },
    alertAShow() {
      this.alertADismissCountDown = this.alertADismissSecs
    },
    // per toast
    makeToast(variant = null, title = 'titolo', message = 'messaggio') {
      this.$bvToast.toast(message, {
        title,
        variant,
        solid: true,
        autoHideDelay: 10000,
      })
    },

  },
  computed: {
    hasChanged() {
      // console.log(this.tracciatiBiglActiveData)
      // console.log(this.tracciatiBiglSavedData)
      return Object.keys(this.tracciatiBiglActiveData).some(field => this.tracciatiBiglActiveData[field] !== this.tracciatiBiglSavedData[field])
    },
  },
})

/* eslint-disable global-require */
</script>

<style lang="scss" >
@import "~@syncfusion/ej2-base/styles/material.css";
@import "~@syncfusion/ej2-buttons/styles/material.css";
@import "~@syncfusion/ej2-vue-buttons/styles/material.css";
@import '~@syncfusion/ej2-dropdowns/styles/material.css';
@import "~@syncfusion/ej2-vue-popups/styles/material.css";
@import "~@syncfusion/ej2-vue-navigations/styles/material.css";
@import '~@syncfusion/ej2-inputs/styles/material.css';
@import '~@syncfusion/ej2-vue-layouts/styles/material.css';
@import '~@syncfusion/ej2-splitbuttons/styles/material.css';
@import '~@syncfusion/ej2-grids/styles/material.css';

.e-btn-icon.e-open-icon {
  background: url('~@/assets/images/svg/open2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-delete-icon {
  background: url('~@/assets/images/svg/garbage-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-download-icon {
  background: url('~@/assets/images/svg/download2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-search-icon {
  background: url('~@/assets/images/svg/search-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-upload-icon {
  background: url('~@/assets/images/svg/upload-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

.e-btn-icon.e-add-icon {
  background: url('~@/assets/images/svg/add2-svgrepo-com.svg');
  height: 18px;
  width: 18px;
}

// per disabilitare la grid
.disablegrid {
  pointer-events: none;
  opacity: 0.4;
}

.wrapper {
  cursor: not-allowed;
}
</style>
